<template>
  <b-row class="h-100">
    <b-col class="container">
      <div
        class="d-flex flex-row justify-content-between align-items-center pl-4 pr-4 pt-3"
      >
        <h5>
          Releases Of Information (ROIs)<br />
          <span class="grid-count color-custom-dark-grey"
            >({{ list.length }} documents)</span
          >
        </h5>
        <div>
          <b-button
            variant="primary"
            class="pl-3 pr-3 pt-1 pb-1 mr-2"
            size="sm"
            @click="openReleaseOfInformationModal"
          >
            <i class="fa fa-plus mr-2"></i> New
          </b-button>
        </div>
      </div>
      <div class="mt-3 mb-0 px-4 w-100 d-flex flex-row justify-content-end">
        <div class="d-flex flex-row justify-content-end align-items-center">
          <top-paginator
            :total="itemsFilter.length"
            :page="paginator.page"
            :perPage="paginator.perPage"
            @change-page="changePage"
          />
        </div>
      </div>
      <div class="px-4">
        <grid
          :groupFeature="false"
          :store="gridConfig.store"
          :columns="columns"
          :autoHeight="true"
          :data="items"
          :selectionMode="gridConfig.selectionMode"
          :columnLines="gridConfig.columnLines"
          :searchFeature="true"
          :stripeFeature="false"
          @renderrows="hookDropdownButtons"
          @renderrow="hookDropdownButtons"
        />
      </div>

      <b-modal
        centered
        ref="release-of-information-selector-modal"
        title="Select Release of Information form"
        header-bg-variant="primary"
        header-text-variant="white"
        @ok="addSubmit"
        no-close-on-backdrop
        header-class="bg-purple"
      >
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button variant="secondary" @click="cancel()">
            Cancel
          </b-button>
          <b-button variant="primary" @click="ok()">
            Continue
          </b-button>
        </template>
        <b-form-group>
          <b-form-radio-group
            name="selected-treatment-plan"
            v-model="selectedreleaseOfInformation"
            :options="releaseOfInformationForms"
            stacked
          ></b-form-radio-group>
        </b-form-group>
      </b-modal>

      <document-file-add-edit-modal
        v-if="showAddFileEditor"
        v-model="showAddFileEditor"
        :formId="formId"
        :eocId="eocId"
        @onModify="onModifyAddFile"
        :clientId="clientId"
        :submitId.sync="submitId"
      />
      <document-add-edit-modal
        v-if="showAddDocumentEditor"
        v-model="showAddDocumentEditor"
        :formId="submitFormId"
        @onModify="onModifyAddDocument"
        :clientId="clientId"
        :eocId="eocId"
        :submitId="submitId"
        :parentDocumentId="parentDocumentId"
        :otherResults="otherResults"
        :defaultValues="defaultValues"
      />
      <document-view-modal
        v-if="showDocumentViewer"
        v-model="showDocumentViewer"
        :documentId="submitId"
        @onModify="onModifyAddDocument"
      />
      <document-share-multiple-modal
        v-if="showDocumentShareModal"
        v-model="showDocumentShareModal"
        :patientId="selectedForms[0].patientId"
        :eocId="selectedForms[0].episodeOfCareId"
        :forms="selectedForms"
        @onModify="onShareDocument"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import { getFormBuilderComponents } from "../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import TopPaginator from "../controls/TopPaginator.vue";
import DocumentAddEditModal from "./document/DocumentAddEditModal.vue";
import DocumentFileAddEditModal from "./document/DocumentFileAddEditModal.vue";
import eocServer from "../../server/eoc";
import patientServer from "../../server/patient";
import releaseOfInformationServer from "../../server/releaseOfInformation";
import DocumentViewModal from "./document/DocumentViewModal.vue";
import DocumentShareMultipleModal from "../episode_of_care/document/DocumentShareMultipleModal.vue";

export default {
  name: "EocViewReleaseOfInformationDocuments",
  components: {
    DocumentViewModal,
    DocumentFileAddEditModal,
    DocumentAddEditModal,
    Grid,
    DocumentShareMultipleModal,
    TopPaginator
  },
  props: ["clientId", "eocId", "showing"],
  data() {
    return {
      list: [],
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false,
        store: {}
      },
      paginator: {
        page: 0,
        perPage: 10
      },
      form: null,
      selectedreleaseOfInformation: null,
      submitId: null,
      submitFormId: null,
      parentDocumentId: null,
      otherResults: [],
      defaultValues: null,
      showAddDocumentEditor: false,
      showAddFileEditor: false,
      showDocumentShareModal: false,
      showDocumentViewer: false
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("formSubmitter", ["deleteFormSubmitterSubmit"]),
    async fetchData() {
      this.getEoc();
      this.getClient();
      await this.fetchFormBuilderForms({
        category: "releaseOfInformation"
      });
      await this.fetchFormSubmitterSubmits();
      if (this.formId) {
        this.form = await this.getFormBuilderFormById(this.formId);
      }
    },
    async getEoc() {
      this.eoc = await eocServer.get(this.eocId);
    },
    async getClient() {
      this.client = await patientServer.get(this.clientId);
    },
    changePage(page) {
      this.paginator.page = page;
    },
    onShareDocument() {
      this.showDocumentShareModal = false;
    },
    async fetchFormSubmitterSubmits() {
      this.list = [];
      const releasesOfInformation = await releaseOfInformationServer.get(
        this.eocId
      );
      this.list = releasesOfInformation;
    },
    addSubmit() {
      this.submitId = null;
      this.submitFormId = this.selectedreleaseOfInformation;
      this.parentDocumentId = null;
      this.otherResults = [];
      this.defaultValues = null;
      this.showAddDocumentEditor = true;
    },
    onModifyAddFile() {
      this.showAddFileEditor = false;
      this.fetchFormSubmitterSubmits();
    },
    onModifyAddDocument() {
      this.showAddDocumentEditor = false;
      this.fetchFormSubmitterSubmits();
    },
    openReleaseOfInformationModal() {
      if (this.releaseOfInformationForms.length > 0) {
        if (this.releaseOfInformationForms.length == 1) {
          this.selectedreleaseOfInformation = this.releaseOfInformationForms[0].value;
          this.addSubmit();
        } else {
          this.openReleaseOfInformationSelectorModal();
        }
      }
    },
    openReleaseOfInformationSelectorModal() {
      this.$refs["release-of-information-selector-modal"].show();
    }
  },
  computed: {
    ...mapState("formBuilder", {
      forms: state => state.list
    }),
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    ...mapGetters("formSubmitter", ["superComputeFormSubmitterValue"]),
    ...mapGetters("client", ["selectedLocation"]),
    formId() {
      return this.selectedLocation.releaseOfInformationFormId;
    },
    itemsFilter() {
      let newList = this.list;
      return newList;
    },
    items() {
      return this.itemsFilter.slice(
        this.paginator.page * this.paginator.perPage,
        (this.paginator.page + 1) * this.paginator.perPage
      );
    },
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    columns() {
      let columns = [];

      columns.push({
        text: "Recipient",
        field: "recipient",
        type: "template",
        width: 150,
        editor: false,
        template: data => {
          const localData = data.record.data;
          return localData.toPatientContact
            ? localData.toPatientContact.name
            : localData.toOrganizationName;
        },
        sortable: false
      });
      columns.push({
        text: "REF#",
        field: "documentRefNumber",
        type: "template",
        width: 50,
        editor: false,
        template: data => data.record.data.document.documentRefNumber,
        sortable: false
      });
      columns.push({
        text: "Type",
        field: "mode",
        type: "template",
        width: 150,
        editor: false,
        template: () => "Release of Information",
        sortable: false
      });
      columns.push({
        text: "Document Status",
        field: "documentStatus",
        type: "template",
        width: 150,
        align: "center",
        editor: false,
        template: data => {
          const status = data.record.data.document.status;
          let className = "warning";
          if (status == "Completed") {
            className = "success";
          }
          if (status == "Draft") {
            className = "danger";
          }
          return `<span class="badge-v2 py-2 badge-${className} badge-fixed-size">${status}</span>`;
        },
        sortable: false
      });
      columns.push({
        text: "Effective date",
        field: "effectiveDate",
        type: "template",
        width: 150,
        editor: false,
        template: data => {
          return this.formatDate(data.record.data.document.effectiveDate);
        },
        sortable: false
      });
      columns.push({
        text: "ROI Status",
        field: "roiStatus",
        type: "template",
        width: 130,
        align: "center",
        editor: false,
        template: data => {
          const status = data.record.data.status;
          let className = "danger";
          if (status == "Active") {
            className = "success";
          }
          return `<span class="badge-v2 py-2 badge-${className} badge-fixed-size">${status}</span>`;
        },
        sortable: false
      });
      columns.push({
        text: "Expiration date",
        field: "expirationDate",
        type: "template",
        width: 150,
        editor: false,
        template: data => {
          return this.formatDateOnly(data.record.data.expirationDate);
        },
        sortable: false
      });
      columns.push({
        text: "Creation",
        field: "creation",
        type: "template",
        width: 250,
        editor: false,
        template: data => {
          const creation = data.record.data.creation.split("\n");
          let result = "";
          creation.forEach(x => {
            result += `${x}<br />`;
          });
          return result;
        },
        sortable: false
      });

      columns.push({
        text: "Tools",
        type: "action",
        field: "action",
        cellCls: "pointer-cell flex-grow-1",
        align: "right",
        width: 70,
        actions: [
          {
            tooltip: "View",
            renderer: () =>
              `<i class="fa fa-search-plus color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"></i>`,
            onClick: ({ record }) => {
              this.submitId = record.data.document.id;
              this.showDocumentViewer = true;
            }
          },
          {
            tooltip: "More",
            renderer: ({ record }) => {
              const actions = [];

              actions.push({
                content: `<i class="fas fa-share fa-sm"></i>Share Document`,
                callback: () => {
                  this.selectedForms = [
                    {
                      formVersionId: record.data.document.versionId,
                      formId:
                        record.data.document.mode == "Group"
                          ? null
                          : record.data.document.form.id,
                      formGroupId:
                        record.data.document.mode == "Group"
                          ? record.data.document.form.id
                          : null,
                      documentId:
                        record.data.document.mode == "Group"
                          ? null
                          : record.data.document.id,
                      documentGroupId:
                        record.data.document.mode == "Group"
                          ? record.data.document.id
                          : null,
                      patientId: record.data.document.patientId,
                      episodeOfCareId: record.data.document.episodeOfCareId,
                      status: record.data.document.status,
                      mode: record.data.document.mode
                    }
                  ];
                  this.showDocumentShareModal = true;
                }
              });

              actions.push({
                content: `<i class="fas fa-edit fa-sm"></i>Edit Document`,
                callback: () => {
                  this.submitId = record.data.document.id;
                  this.submitFormId = record.data.document.formId;
                  this.parentDocumentId = record.data.document.patientId;
                  this.showAddDocumentEditor = true;
                }
              });
              if (record.data.status == "Active") {
                actions.push({
                  content: `<span class="text-danger"><i class="fas fa-ban fa-sm"></i>Revoke ROI</span>`,
                  callback: async () => {
                    await releaseOfInformationServer.changeStatus(
                      record.data.id
                    );
                    await this.fetchData();
                  }
                });
              } else {
                actions.push({
                  content: `<span class="text-success"><i class="fas fa-check-circle fa-sm"></i>Activate ROI</span>`,
                  callback: async () => {
                    await releaseOfInformationServer.changeStatus(
                      record.data.id
                    );
                    await this.fetchData();
                  }
                });
              }

              actions.push({
                content: `<i class="fas fa-trash-alt fa-sm"></i>Delete ROI`,
                callback: () => {
                  this.$dialog
                    .confirm(
                      {
                        title: "Are you sure you want to delete this record?"
                      },
                      {
                        view: "confirm-delete"
                      }
                    )
                    .then(async () => {
                      await releaseOfInformationServer.delete(record.data.id);
                      await this.fetchData();
                    })
                    .catch(function() {});
                }
              });

              return this.createDropdownButton({
                items: actions,
                menuWidth: 150
              });
            }
          }
        ]
      });
      return columns;
    },
    formHasComponents() {
      return (
        this.form &&
        getFormBuilderComponents(this.form.current.content).length > 0
      );
    },
    releaseOfInformationForms() {
      return this.forms["releaseOfInformation"].map(form => ({
        value: form.id,
        text: form.name
      }));
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        await this.fetchData();
      }
    }
  }
};
</script>

<style scoped>
.grid-count {
  font-size: 0.8rem;
}
</style>
